import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const staffAPI = createApi({
    reducerPath: "staffAPI",
    baseQuery,
    endpoints: (builder) => ({
        // Staffs
        getAllStaffs: builder.mutation({
            query: ({ page, size, search }) => {
                let apiUrl = `staff?page=${page + 1}&size=${size}`;

                if (search) {
                    apiUrl += `&search=${search}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["staff"],
        }),
        getStaffById: builder.mutation({
            query: ({id}) => {
                let apiUrl = `staff/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        getMyStaffProfile: builder.mutation({
            query: () => {
                let apiUrl = `admin/profile`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createStaff: builder.mutation({
            query: ({body}) => ({
                url: `staff`,
                method: "POST",
                body
            }),
            invalidatesTags: ["staff"],
        }),
        updateStaff: builder.mutation({
            query: ({ id, body }) => ({
                url: `staff/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["staff"],
        }),
        updateMyStaffProfile: builder.mutation({
            query: ({ body }) => ({
                url: `profile`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["staff"],
        }),
        deleteStaff: builder.mutation({
            query: ({id}) => ({
                url: `staff/${id}`,
                method: "DELETE",
                body: {}
            }),
            invalidatesTags: ["staff"],
        }),
        updateStaffPassword: builder.mutation({
            query: ({ id, body }) => ({
                url: `staff/${id}/reset-password`,
                method: "PATCH",
                body
            })
        }),
        
        //Roles
        getAllRoles: builder.mutation({
            query: () => {
                let apiUrl = `roles`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["roles"],
        }),
        getRoleById: builder.mutation({
            query: ({id}) => {
                let apiUrl = `roles/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createRole: builder.mutation({
            query: ({body}) => ({
                url: `roles`,
                method: "POST",
                body
            }),
            invalidatesTags: ["roles"]
        }),
        updateRole: builder.mutation({
            query: ({id, body}) => ({
                url: `roles/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["roles"]
        }),
        deleteRole: builder.mutation({
            query: ({id}) => ({
                url: `roles/${id}`,
                method: "DELETE",
                body: {}
            }),
            invalidatesTags: ["roles"],
        }),

        //Forgot Password
        staffForgotPassword: builder.mutation({
            query: ({body}) => ({
                url: `admin/forget-password`,
                method: "POST",
                body
            })
        }),
    }),
});

export const { 
    useGetAllStaffsMutation,
    useGetStaffByIdMutation,
    useGetMyStaffProfileMutation,
    useCreateStaffMutation,
    useUpdateStaffMutation,
    useUpdateMyStaffProfileMutation,
    useDeleteStaffMutation,
    useUpdateStaffPasswordMutation,

    useGetAllRolesMutation,
    useGetRoleByIdMutation,
    useCreateRoleMutation,
    useUpdateRoleMutation,
    useDeleteRoleMutation,

    useStaffForgotPasswordMutation
} = staffAPI;

export default staffAPI;